import styled from 'styled-components';

import {
  scale040,
  scale060,
  scale080,
  scale090,
  scale100,
  scale110,
  scale120,
  scale130,
  scale140,
  scale150,
  scale160,
  scale170,
  scale200,
} from '@xingternal/tokens';

import { Hero as XingternalHero, Headline } from '@xingternal/typography';
import { Button as XingternalButton } from '@xingternal/button';
import {
  mediaConfined,
  mediaConfinedNavlessOnly,
  mediaSmallOrTiny,
} from '@xingternal/layout-tokens';

import {
  sectionWideInnerContainerMixin,
  CONTAINER_PADDING,
} from '../../variables.style';
import InternalPicture from '../../Picture/Picture';

export const Container = styled.div`
  padding-left: ${CONTAINER_PADDING};
  padding-right: ${CONTAINER_PADDING};
  margin-left: auto;
  margin-right: auto;
  padding-top: ${scale110};
  overflow: hidden;

  & img {
    max-width: 100%;
  }

  @media ${mediaConfined} {
    padding-top: ${scale170};
  }

  @media ${mediaConfinedNavlessOnly} {
    padding-top: ${scale150};
  }
`;

export const InnerContainer = styled.div`
  ${sectionWideInnerContainerMixin};
  padding-bottom: ${scale160};
  display: flex;

  @media ${mediaConfined} {
    padding-bottom: ${scale080};
  }
`;

export const Content = styled.div`
  margin-top: 0;

  @media ${mediaConfined} {
    width: 57%;
    flex: 1 0 auto;
    margin-top: ${scale120};
    margin-right: ${scale140};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  @media ${mediaConfinedNavlessOnly} {
    width: 100%;
  }
`;

export const PictureContainer = styled.div`
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;

  @media ${mediaSmallOrTiny} {
    display: none;
  }

  @media ${mediaConfinedNavlessOnly} {
    display: none;
  }
`;

export const MobilePictureContainer = styled.div`
  display: none;
  margin-bottom: ${scale060};

  @media ${mediaSmallOrTiny} {
    ${({ $noImageHandheld }) =>
      !$noImageHandheld &&
      `
    height: 180px;
    display: block;
  `}
  }

  @media ${mediaConfinedNavlessOnly} {
    height: 280px;
    display: block;
  }
`;

export const Picture = styled(InternalPicture)`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${mediaSmallOrTiny} {
    height: 100%;

    & img {
      height: 100%;
    }
  }

  @media ${mediaConfinedNavlessOnly} {
    height: 100%;

    & img {
      height: 100%;
    }
  }
`;

export const Hero = styled(XingternalHero)`
  margin-bottom: ${scale040};

  @media ${mediaConfined} {
    margin-bottom: ${scale080};
  }

  @media ${'(max-width: 394px)'} {
    font-size: ${scale130};
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-top: ${scale090};

  @media ${mediaConfined} {
    margin-top: ${scale200};
  }

  @media ${mediaConfinedNavlessOnly} {
    margin-top: ${scale130};
  }
`;

export const ButtonsSection = styled.div`
  margin-top: ${scale100};

  @media ${mediaConfined} {
    display: flex;
    margin-top: 0;
    max-width: 580px;
  }
`;

export const Button = styled(XingternalButton)`
  width: 100%;

  &:nth-child(1) {
    margin-bottom: ${scale040};
  }

  @media ${mediaConfined} {
    &:nth-child(1) {
      margin-right: ${scale060};
      margin-bottom: 0;
    }
  }
`;
